import React from "react";
import { Button } from "@mui/material";

const ResponseOptionButton = ({ displayText, value, onClick }) => {
  const themeMode = window.__ASKBLAZE_THEME_MODE__ === "dark" ? "dark" : "light";
  return (
    <Button
      variant="outlined"
      onClick={() => onClick(value)}
      sx={{
        width: "45%",
        borderRadius: "5px",
        textTransform: "none",
        borderColor: themeMode === "dark" ? "#033319" : "#1A5632",
        bgcolor: themeMode === "dark" ? "#033319" : "#ffffff",
        color: themeMode === "dark" ? "#ffffff" : "#033319",
        "&:hover": {
          borderColor: themeMode === "dark" ? "#033319" : "#145028",
          backgroundColor: themeMode === "dark" ? "#fdb913" : "#1A5632",
          color: themeMode === "dark" ? "#1A5632" : "#ffffff",
        },
      }}
    >
      {displayText}
    </Button>
  );
};

export default ResponseOptionButton;
